import { useRef } from 'react';

export const Step = (
  Component,
  id,
  titleKey,
  descriptionKey,
  shortNameKey,
  t,
  hasShortBr = false,
) => ({
  Component,
  props: {
    id,
    hasShortBr,
    title: t(titleKey),
    description: t(descriptionKey),
    shortName: t(shortNameKey),
  },
  ref: useRef(null),
});
